{
  "loading": "Učitavam...",
  "placeholder": "Izaberite..."
}
